var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 137.42 89.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d1a782;}.cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-2{fill:#1c2c58;}.cls-3{fill:#fff;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12.48,
    y1: 89.87,
    x2: 12.48,
    y2: 61.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c2c58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1a782"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 32.98,
    y1: 84.39,
    x2: 32.98,
    y2: 62.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 55.1,
    y1: 84.02,
    x2: 55.1,
    y2: 62.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 75.97,
    y1: 84.02,
    x2: 75.97,
    y2: 62.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 91.14,
    y1: 84.02,
    x2: 91.14,
    y2: 62.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 106.87,
    y1: 84.02,
    x2: 106.87,
    y2: 62.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 127.3,
    y1: 84.02,
    x2: 127.3,
    y2: 62.27,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "quality") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.22,34.1l-9,15.6,8.6-.52L57,56.52,66.5,40.11c-.91-.59-1.79-1.58-2.71-1.78-1.51-.33-3.74.84-5.15.21-1.23-.56-1.51-2.85-2.58-3.68a5.23,5.23,0,0,0-1.84-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.68,33.89a2.82,2.82,0,0,0-1,.47c-1.2,1-1.66,3.4-3,4.09-1.21.61-3.2-.6-4.52-.3-1.16.27-2.32,1.53-3.5,2.1L79,56.52l3.21-7.34,8.6.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.71,37c-1.14.57-3-.58-4.28-.29C71,37.08,69.6,39,68.14,39c-1.29,0-2.48-1.81-3.73-2.09-1.43-.31-3.54.79-4.87.2-1.17-.53-1.43-2.69-2.44-3.48s-3.54-.8-4.48-1.9-.11-3-.67-4.18-2.84-2.23-3.2-3.63c-.32-1.23,1.23-2.78,1.23-4,0-1.45-1.58-3.23-1.29-4.64.26-1.24,2.34-2,2.89-3.12.62-1.3,0-3.57.88-4.72.78-1,3-.77,4-1.57S58,2.62,59.31,2c1.14-.57,3,.58,4.27.29C65,1.93,66.42,0,67.88,0c1.28,0,2.47,1.81,3.73,2.09,1.43.31,3.54-.79,4.87-.2,1.17.53,1.43,2.69,2.44,3.48s3.54.8,4.48,1.9.11,3,.67,4.18c.65,1.29,2.84,2.23,3.2,3.63.32,1.23-1.24,2.78-1.23,4,0,1.44,1.58,3.23,1.29,4.64-.26,1.24-2.34,2-2.89,3.11-.63,1.3,0,3.58-.88,4.73s-3,.77-4,1.57S78,36.39,76.71,37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.7,19.5A15.71,15.71,0,1,1,79.1,8.41,15.66,15.66,0,0,1,83.7,19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.72,19.5a13.71,13.71,0,1,1-4-9.69,13.71,13.71,0,0,1,4,9.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,19.7l4.39,4.38,2.29,2.29,2.28-2.29,9.16-9.15-2.29-2.29-9.15,9.15-4.39-4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M10.28,84.42A10.44,10.44,0,0,1,4.83,83a9.34,9.34,0,0,1-3.57-3.91,13.18,13.18,0,0,1-1.26-6,13.32,13.32,0,0,1,1.26-6,9.32,9.32,0,0,1,3.58-3.92,10.42,10.42,0,0,1,5.47-1.39,10.41,10.41,0,0,1,5.46,1.39,9.3,9.3,0,0,1,3.58,3.91,13.18,13.18,0,0,1,1.26,6,13.32,13.32,0,0,1-1.26,6A9.32,9.32,0,0,1,15.77,83,10.56,10.56,0,0,1,10.28,84.42Zm.57-2.16q5.55,0,5.54-8.3,0-4.8-1.72-7.36A5.56,5.56,0,0,0,9.76,64q-5.55,0-5.54,8.3,0,4.82,1.72,7.37A5.57,5.57,0,0,0,10.85,82.26Zm8.31,7.61a11.73,11.73,0,0,1-6.26-1.61,9.33,9.33,0,0,1-3.83-4.61l3.7-1.43q1.75,5.31,7.53,5.32a14.39,14.39,0,0,0,2.42-.21A10.92,10.92,0,0,0,25,86.72l-.15,1.85a8.32,8.32,0,0,1-2.51,1A14.33,14.33,0,0,1,19.16,89.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M24.85,66V62.88l.33,1.47-2.66-.63.11-1.45H31.4l-.11,1.4a10.45,10.45,0,0,1-1.32.42c-.54.15-1.16.29-1.84.44l.5-1.65V66Zm0,11.71V62.58h3.78V77.21ZM33,84.39a9.06,9.06,0,0,1-6-1.82,6,6,0,0,1-2.22-4.9l3.78-.46A4.45,4.45,0,0,0,29.9,80.6a5.1,5.1,0,0,0,3.63,1.2,5.1,5.1,0,0,0,3.63-1.2,4.41,4.41,0,0,0,1.27-3.39l2.77.46A6,6,0,0,1,39,82.57,9.07,9.07,0,0,1,33,84.39ZM38.43,66V62.88l.42,1.47-3.28-.63.11-1.45h7.76l-.11,1.4a12.59,12.59,0,0,1-2.55.86l.42-1.65V66ZM41.2,77.67l-2.77-.46V62.58H41.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.5,62.27,48.74,82.59l-.16-.66,2.68.64L51.15,84H44.23l.11-1.41a7.69,7.69,0,0,1,1.23-.49A12.61,12.61,0,0,1,47,81.78l-1,.81,7.18-20.34ZM49.28,77.85,50,75.74h9.34l.75,2.11Zm7.54-15.71,7.23,20.45-1-.63,2.88.61L65.85,84H57.63l.11-1.49a12.85,12.85,0,0,1,2.62-.77l-.29.61L53.92,63.65l-.75-1.4a14.62,14.62,0,0,1,1.76-.14Q55.92,62.1,56.82,62.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M76.93,62.27l-.11,1.4c-.52.17-1.09.32-1.72.47s-1.28.26-1.95.35l.44-1.61V66H69.9V62.88l.37,1.47-2.92-.63.11-1.45ZM67.43,84l.11-1.41a21.46,21.46,0,0,1,2.79-.85l-.43,1.65V80.33h3.69v3.08l-.38-1.48,2.93.64L76,84Zm2.47-.33V62.58h3.69V83.69Zm1.84.33v-2.2h11l.9,2.2Zm11.91,0L80,82.86l3.17-6h1.4A26.16,26.16,0,0,1,83.65,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M95.45,62.27l-.11,1.4a19.11,19.11,0,0,1-2.79.86L93,62.88V66H89.3V62.88l.37,1.47-2.92-.63.11-1.45ZM86.84,84,87,82.61a20.54,20.54,0,0,1,2.79-.85l-.44,1.65V80.33H93v3.08l-.38-1.48,2.93.64L95.43,84Zm2.46-.33V62.58H93V83.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M97.49,68.75a23.9,23.9,0,0,1,.35-6.48l3.41,1.25L99,68.75Zm.75-4.28-.4-2.2h18.07l-.8,2.2Zm4,19.55.11-1.41q.66-.24,1.47-.45c.54-.14,1.1-.26,1.67-.38L105,83.41V80.33h3.69v3.08l-.42-1.48,3.32.64L111.51,84Zm2.81-.33V62.58h3.69V83.69Zm9.73-14.94-2.26-5.23,3.41-1.25a23.9,23.9,0,0,1,.35,6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M125.66,76.68,119,63.7l1.06.63-2.88-.61.11-1.45h8.44l-.11,1.45a13.7,13.7,0,0,1-2.81.75l.17-.55,5.63,11.25.52,1.4ZM122.74,84l.11-1.41q.66-.24,1.47-.45c.54-.14,1.1-.26,1.67-.38l-.44,1.63V80.33h3.69v3.08l-.41-1.48,3.31.64L132,84Zm2.81-.33V75.14h3.69v8.55Zm1.21-7.14L133,63.7l.11.65-2.94-.63.11-1.45h7.14l-.11,1.4a7.69,7.69,0,0,1-1.23.5,13.17,13.17,0,0,1-1.41.34l1.08-.81-6.62,12.87Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.ddca11b4ca58f4c60b9cf6b2f4ead1e3.svg";
export { ForwardRef as ReactComponent };